const { PreconditionError } = require('../errors');

/**
 * Builds a small finite-state machine for an entity's status field.
 *
 * @param {Object} config
 * @param {string[]} config.states - all valid states
 * @param {string} config.initial - the state a new entity starts in
 * @param {Object<string,string[]>} config.transitions - map of state -> states it may move to
 * @param {string} [config.entityName] - used in error messages
 */
const createStatusMachine = ({ states, initial, transitions, entityName = 'entity' }) => {
  const stateSet = new Set(states);

  if (!stateSet.has(initial)) {
    throw new Error(`Invalid status machine for ${entityName}: initial state "${initial}" is not in states`);
  }

  const canTransition = (from, to) => {
    if (from === to) return false;
    const allowed = transitions[from] || [];
    return allowed.includes(to);
  };

  const isTerminal = (state) => (transitions[state] || []).length === 0;

  const assertTransition = (from, to) => {
    if (!stateSet.has(from)) {
      throw new PreconditionError(`${entityName} has unknown status "${from}"`);
    }
    if (!stateSet.has(to)) {
      throw new PreconditionError(`Cannot transition ${entityName} to unknown status "${to}"`);
    }
    if (!canTransition(from, to)) {
      throw new PreconditionError(`${entityName} cannot transition from "${from}" to "${to}"`);
    }
    return to;
  };

  return { states, initial, canTransition, assertTransition, isTerminal };
};

module.exports = { createStatusMachine };
